import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TRoutesViewModel } from '@shared/models';

@Component({
    'selector': 'app-route8Congratulations',
    'templateUrl': './route8Congratulations.page.html',
    'styleUrls': ['./route8Congratulations.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})

export class Route8CongratulationsPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: TRoutesViewModel;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTE_PAGE8);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.vm = super.getViewModel();

        this.eventsService.publish(Constants.EVENT_TRACK_USAGE, { 'viewname': this.Constants.VIEW_ROUTES });
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-route-8-tour');
    // }

    public onRoutesClick() {
        this.router.navigateByUrl('/routes');
    }

    public onNavigationClick() {
        this.router.navigateByUrl('/navigationPage1');
    }
}
